import type { HierarchyItemWithLevels } from '@openx/types/hierarchyItem';

export const filterWithParents = (
  inventories: HierarchyItemWithLevels[],
  searchPhrase: string
): HierarchyItemWithLevels[] => {
  const searchPhraseLowerCase = searchPhrase.toLowerCase();

  return inventories
    .reduceRight<HierarchyItemWithLevels[]>((result, item) => {
      const isMatch = item.name.toLowerCase().includes(searchPhraseLowerCase);
      const isParentOfPrevious = result.length > 0 && result[result.length - 1].level > item.level;

      if (isMatch || isParentOfPrevious) {
        result.push(item);
      }

      return result;
    }, [])
    .reverse();
};
